// Import the necessary components
import VerofreshRecord from './VerofreshRecord'

class VehicleIssueRecord extends VerofreshRecord {
  static get TYPE_NO_DATA () { return 'no-data' }
  static get TYPE_NO_GPS_DATA () { return 'no-gps-data' }
  static get TYPE_GPS_ZERO () { return 'gps-zero' }
  static get TYPE_NO_COOLER_SENSOR_DATA () { return 'no-cooler-sensor-data' }
  static get TYPE_NO_FREEZER_SENSOR_DATA () { return 'no-freezer-sensor-data' }

  static get TYPE_CONSISTENT_HOT_VIOLATIONS () { return 'consistent-hot-violations' }
  static get TYPE_CONSISTENT_COLD_VIOLATIONS () { return 'consistent-cold-violations' }
  static get TYPE_CONSISTENT_NO_DATA_VIOLATIONS () { return 'consistent-no-data-violations' }
  static get TYPE_CONSISTENT_GPS_GAP_VIOLATIONS () { return 'consistent-gps-gap-violations' }
  static get TYPE_CONSISTENT_SET_POINT_VIOLATIONS () { return 'consistent-set-point-violations' }
}

export default VehicleIssueRecord
